import React, { useEffect, useState } from 'react';
import "./Transcripts.css"
import TranscriptsView from '../components/SettingsComponents/TranscriptsView';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { logEvent } from '../utils/logger';
import { PageHeader, Skeleton } from '../components/ui/Primitives';
import { signInPath } from '../utils/callLinks';


function Transcripts({ checkLogin, organization, orgMember }) {
  const [updatedOrgMember, setUpdatedOrgMember] = useState(orgMember);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  // <-- NEW: notify chat widget
  useEffect(() => {
    if (!isLoading && updatedOrgMember) {
      const iframe = document.getElementById('chat-iframe');
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({ type: 'page.navigation', page: 'Calls' }, '*');
      }
    }
  }, [isLoading, updatedOrgMember]);

  useEffect(() => {
    async function fetchUserData() {

      if (!localStorage.getItem('jwt_authorization')) {
        navigate(signInPath(), { replace: true });
        return;
      }

      if (orgMember) {
        setIsLoading(true); // Start loading

        try {
          const jwt_token = localStorage.getItem('jwt_authorization');

          if (!jwt_token) {
            navigate(signInPath(), { replace: true });
            return null;
          }
          // console.log('Transcripts useEffect');
          // console.log(updatedOrgMember);
          const event = {
            event: {
              label: 'PageView',
              data: {
                page: 'Calls',
                user_id: updatedOrgMember ? updatedOrgMember.user_id : null
              }
            }

          }

          logEvent(event);

          const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/v2/organization/${orgMember.organization_id}/members/${orgMember.id}`, {
            jwt_token, op: 'get'
          });

          if (response.status === 200) {
            
            setUpdatedOrgMember(response.data);

            setIsLoading(false); // Stop loading after user data is set
          }
        } catch (err) {
          if (err.response?.status === 401) {
            localStorage.removeItem('jwt_authorization');
            navigate(signInPath(), { replace: true });
          }
          setIsLoading(false); // Stop loading in case of error
        }
      }

      
    }
    fetchUserData();

  }, [orgMember]);

  if (!isLoading && updatedOrgMember) { // Render only when not loading and user data is available
    return (

      <div className="page-content calls-page">
        <PageHeader eyebrow="Calls" title="Call history" description="Review your calls, personal messages, and general messages available to you." />
        <TranscriptsView orgMember={updatedOrgMember} />
      </div>


    );
  } else {

    return (

      <div className="page-content calls-page"><Skeleton width="40%" height={42} /><Skeleton height={300} /></div>


    );
  }




}

export default Transcripts;
